import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import {
  clearPackageResultsAction, searchPackageAction, searchPackageFlightsForMobileAction,
  searchPackageFlightsForMobileErrorAction, searchPackageFlightsForMobileSuccessAction,
  searchPackageFlightsForMobileWithPaginationSuccessAction
} from '@packages/packages-result/store/actions/packages-result.actions';
import { AirResultOptionResponse } from '@packages/packages-result/entities/air-results';

export interface FlightResultsPackageState extends EntityState<AirResultOptionResponse> { }

function getId(flightResult: AirResultOptionResponse): number {
  return flightResult.OptionId;
}

export const flightResultsAdapter: EntityAdapter<AirResultOptionResponse> = createEntityAdapter<AirResultOptionResponse>({
  selectId: getId
});

export const initialState: FlightResultsPackageState = flightResultsAdapter.getInitialState({});

export const reducer = createReducer(
  initialState,
  on(
    searchPackageAction,
    searchPackageFlightsForMobileAction,
    () => initialState
  ),
  on(searchPackageFlightsForMobileSuccessAction, (state, { response }) =>
    flightResultsAdapter.setAll(response.AirResults, state)),
  on(searchPackageFlightsForMobileWithPaginationSuccessAction, (state, { response }) =>
    flightResultsAdapter.addMany(response.AirResults, state)),
  on(searchPackageFlightsForMobileErrorAction, (state) => flightResultsAdapter.removeAll(state)),
  on(clearPackageResultsAction, (state) => flightResultsAdapter.removeAll(state))
);

export function flightResultsReducer(state: FlightResultsPackageState, action: Action): FlightResultsPackageState {
  return reducer(state, action);
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = flightResultsAdapter.getSelectors();

export const exportedForTesting = {
  getId,
};
